import React, { Component } from 'react'
import { AvtarImgs, InsightBodyData, InsightRowData, ProfileDivs, UserNames } from '../styles/main'

class ContactBodyTheme extends Component {
  render() {
    return (
      <div>
        <InsightBodyData>
          <ProfileDivs>
            <AvtarImgs>
              <img src="/images/LoginAgent.png" />

            </AvtarImgs>
            <UserNames>
              Leonard	Campbell
              <div>+91 980-798-8989</div>
            </UserNames>
          </ProfileDivs>
        </InsightBodyData>
        <div class="container-fluid">
          <section class="chatbox">
            <div class="msgpart">
              <div class="img">
                <span class="user-avtar">
                  <img src="/images/LoginAgent.png" class="img-fluid" alt="" />
                  <img src="/images/LoginAgent.png" class="status" alt="" />
                </span>
              </div>
              <div class="rchat">
                <p class="m-0">With preset responses, for the commonly asked questions, hasten the resolution process with quick responses and boost customer satisfaction.</p>
                <div class="time">
                  <span class="time-done d-flex align-items-center">
                    <p class="m-0">12:30 PM</p>
                    <img src="" class="img-fluid" alt="" />
                  </span>
                </div>
              </div>
              <div class="more-option">
                <a href="#" class="ulinaLink"><span class="material-symbols-outlined">
                  more_vert
                </span></a>
              </div>
            </div>
            <div class="msgpart reply">
              <div class="img">
                <span class="user-avtar">
                  <img src="/images/LoginAgent.png" class="img-fluid" alt="" />
                  <img src="/images/LoginAgent.png" class="status" alt="" />
                </span>
              </div>
              <div class="rchat">
                <p class="m-0">With preset responses, for the commonly asked questions, hasten the resolution process with quick responses and boost customer satisfaction.</p>
                <div class="time">
                  <span class="time-done d-flex align-items-center">
                    <p class="m-0">12:30 PM</p>
                    <img src="" class="img-fluid" alt="" />
                  </span>
                </div>
              </div>
              <div class="more-option">
                <a href="#" class="ulinaLink"><span class="material-symbols-outlined">
                  more_vert
                </span></a>
              </div>
            </div>
          </section>
        </div>
        <div class="col-sm-12 sent-msg">
                    <div class="col-sm-12 write-msg">

                       <textarea class="form-control" placeholder="Write you message ...."></textarea>

                       <div class="msg-img">
                        <div class="smiley-img">
                            <a href="#" target="_blank">
                                <span class="material-symbols-outlined">
                                    emoji_emotions
                                    </span>
                            </a>
                           </div>

                           <div class="attach-img">
                            <a href="#" target="_blank">
                                <span class="material-symbols-outlined">
                                    attach_file
                                    </span>
                            </a>
                           </div>

                           <div class="send-img">
                            <a href="#" target="_blank">
                                <span class="material-symbols-outlined">
                                    send
                                    </span>
                            </a>
                           </div>
                       </div>





                    </div>


           </div>
      </div>
    )
  }
}

export default ContactBodyTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactBodyTheme.js